import {
  http
} from '../config';
import base from './base';

export const schedule={
  getSchedulueList(classDate){ //sechedule management 课程管理
    return http({
      url:`${base.datebook}/teacherClass/queryScheduleStatus/${classDate}`,
      method:'get',
    });
  },
  modifySchedule(data){//单个修改老师时间状态
    return http({
      url:`${base.datebook}/teacherClass/updateSchedule`,
      method:'post',
      data
    });
  },
  updateScheduleWithLink(data){
    return http({
      url:`${base.datebook}/teacherClass/updateScheduleWithLink`,
      method:'post',
      data
    });
  },
  modifyAllSchedule(data){
    return http({
      url:`${base.datebook}/teacherClass/updateScheduleBatch`,
      method:'post',
      data
    });
  },
  slotsOperationDetails(data){
    return http({
      url:`${base.users}/tea/slotsOperationDetails`,
      method:'post',
      data,
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/schedule.js